<template>
  <div class="home_wrap">
    <!-- <header-bar></header-bar> -->
    <div class="list_wrap">
      <div class="list_main">
        <div class="action_bar">
          <div class="search_bar">
            <el-date-picker
              v-model="time"
              type="daterange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              value-format="timestamp"
              size="small"
              @change="timeChange"
              width="200"
            >
            </el-date-picker>
            <el-input
              v-model="keyword"
              class="filter"
              placeholder="请输入关键词"
              size="small"
            ></el-input>
            <el-button
              type="primary"
              icon="el-icon-plus"
              size="small"
              @click="createProject"
            >
              新建项目
            </el-button>
          </div>
          <div class="recycle" @click="visible = true">
            <i class="fa fa-trash-o"></i>回收站
          </div>
        </div>
        <div class="survey_list_table">
          <el-table
            :data="tableData"
            style="width: 100%; "
            :height="tableHeight"
            border
            :header-cell-style="tableStyle"
          >
            <el-table-column type="index" align="center" width="50">
            </el-table-column>
            <el-table-column
              prop="title"
              label="标题"
              align="left"
              header-align="center"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column label="问卷类型" align="center" width="100">
              <template #default="{ row }">
                <i v-if="row.type === 'online'" class="el-icon-mobile-phone" />
                <i v-else class="el-icon-place" />
                {{ row.type | formatType }}
              </template>
            </el-table-column>
            <el-table-column label="状态" align="center" width="110">
              <template #default="{ row }">
                <img :src="statusIcon[row.status]" height="12" />
                {{ row.status | surveyStatusCn }}
              </template>
            </el-table-column>
            <el-table-column label="调查进度" width="200" align="center">
              <template #default="{ row }">
                <div class="progress-bar-wrapper">
                  <div class="progress-bar">
                    <el-progress
                      :status="
                        row.progress.total &&
                        row.progress.total === row.progress.completed
                          ? 'success'
                          : null
                      "
                      :show-text="false"
                      :percentage="
                        row.progress.total
                          ? (row.progress.completed / row.progress.total) * 100
                          : 0
                      "
                    ></el-progress>
                  </div>
                  <div class="label">
                    {{ row.progress.completed }} / {{ row.progress.total }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="created_at"
              label="创建时间"
              align="center"
              width="170"
            >
            </el-table-column>
            <!-- <el-table-column
              prop="updated_at"
              label="编辑时间"
              align="center"
              width="170"
            > </el-table-column> -->
            <el-table-column label="操作" align="center" width="150">
              <template #default="{ row }">
                <div class="links">
                  <div class="link" @click="handleEdit(row)">编辑</div>
                  <div class="link" @click="release(row)">
                    {{ row.type === "online" ? "发布" : "分配" }}
                  </div>
                  <div class="link" @click="stat(row)">数据</div>
                  <el-dropdown
                    trigger="click"
                    placement="bottom-start"
                    @command="handleCommand($event, row)"
                  >
                    <div class="link">
                      <i class="iconfont icon-gengduo"></i>
                    </div>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="delete">删除</el-dropdown-item>
                      <el-dropdown-item command="duplicate"
                        >复制</el-dropdown-item
                      >
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination">
          <el-pagination
            background
            :current-page="pagination.current_page"
            :page-size="pagination.per_page"
            layout="total, prev, pager, next, jumper"
            :total="pagination.total"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
        <!-- <div class="list_foot">
          <div class="logo">
            <img src="@/assets/images/user/logo2.svg" height="40" />
            <div class="logo_text_foot">
              <div class="cn">月兔调查</div>
              <div class="en">YueTu&nbsp;&nbsp;Survey</div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <recycle-dialog :show.sync="visible" @refresh="getSurveys"></recycle-dialog>
  </div>
</template>

<script>
// import HeaderBar from "./HeaderBar";
import {
  getSurveys,
  softDeleteSurvey,
  createSurvey,
  duplicateSurvey,
} from "@/api/survey";

import RecycleDialog from "./recycle-dialog";
import uuid from "uuid";
import green from "@/assets/images/user/green.svg";
import blue from "@/assets/images/user/blue.svg";
import red from "@/assets/images/user/red.svg";
import gray from "@/assets/images/user/gray.svg";

export default {
  data() {
    return {
      visible: false,
      time: null,
      keyword: "",
      timeOut: null,
      tableStyle: {
        color: "#6F6F6F",
        "background-color": "#F5F7F9",
        "border-color": "#E3E8EE",
      },
      //状态所对应的icon
      statusIcon: {
        editing: blue,
        published: green,
        stay: gray,
        ended: red,
      },
      tableData: [],
      pagination: {},
      tableHeight: 0,
    };
  },
  watch: {
    keyword() {
      clearTimeout(this.timeOut);
      this.timeOut = setTimeout(() => {
        this.getSurveys();
      }, 600);
    },
  },
  created(){
    // 計算屏幕的高度
    let height = document.documentElement.clientHeight;
    this.tableHeight = height - 200;
  },
  mounted() {
    // eslint-disable-next-line no-console
    this.getSurveys();
  },
  beforeRouteLeave(to, from, next) {
    // eslint-disable-next-line no-console
    if (to.name == "home") {
      from.meta.keepAlive = false;
      to.meta.keepAlive = false;
      this.$destroy();
      next();
    } else {
      if (!from.meta.keepAlive) {
        from.meta.keepAlive = true;
      }
      next();
    }
  },
  methods: {
    // 查询问卷列表
    getSurveys() {
      let query = {};
      if (this.pagination.current_page)
        query.page = this.pagination.current_page;
      if (this.keyword) query.title = this.keyword;
      if (this.time) {
        query.startTimeStamp = this.time[0] / 1000;
        query.endTimeStamp = this.time[1] / 1000;
      }
      getSurveys(query).then((res) => {
        this.tableData = res.data;
        this.pagination = res.meta.pagination;

        this.pagination = res.meta.pagination;
      });
    },
    handleEdit(row) {
      this.$router.push({
        name: 'SurveyEdit',
        params: {
          id: row.id
        }
      });
    },

    handleShowTypeChange() {
      this.$router.push({ name: "ProjectList" });
    },
    createProject() {
      this.createSurvey();
    },

    createSurvey() {
      let survey = this.defaultSurvey();
      this.$confirm("请选择问卷类型", "提示", {
        distinguishCancelAndClose: true,
        closeOnClickModal: false,
        confirmButtonText: "线上问卷",
        cancelButtonText: "线下调查",
        callback: (action) => {
          if (action === "close") return;
          let type = {
            confirm: "online",
            cancel: "offline",
          };
          survey.type = type[action];
          createSurvey(survey).then((res) => {
            this.$router.push({
              name: 'SurveyEdit',
              params: {
                id: res.data.id
              }
              // path: `/survey/${res.data.id}/edit`,
            });
          });
        },
      });
    },
    // 编辑问卷
    // 发布问卷
    release(row) {
      // let type = {
      //   online: "/collect/link",
      //   offline: "/task/person",
      // };
      // this.$router.push({
      //   path: `${type[row.type]}/${row.id}`,
      // });
      if(row.type=='online') {
        this.$router.push({
          name: 'SurveySurveyors',
          params: {
            id: row.id
          }
        })
      } else {
        this.$router.push({
          name: 'SurveyTasks',
          params: {
            id: row.id
          }
        })
      }
    },
    stat(row) {
      this.$router.push({
        name: "SurveyAnswers",
        params: {
          id: row.id,
        },
      });
    },
    handleCommand(command, row) {
      if (command === "delete") {
        this.softDeleteSurvey(row.id);
      }

      if (command === "duplicate") {
        this.duplicateSurvey(row.id);
      }
    },
    //删除拍拍
    // 软删除
    softDeleteSurvey(id) {
      this.$confirm("确定要移入回收站吗？", "删除问卷确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      })
        .then(() => {
          softDeleteSurvey(id).then(() => {
            this.$message({
              type: "success",
              center: true,
              message: "删除成功",
              duration: 1500,
            });
            this.getSurveys();
          });
        })
        .catch(() => {});
    },

    duplicateSurvey(id) {
      duplicateSurvey({ id })
        .then(() => {
          this.$message.success("问卷复制成功");
          this.getSurveys();
        })
        .catch(() => {
          this.$message.error("问卷复制失败");
        });
    },
    defaultSurvey() {
      return {
        id: uuid(Date.parse(new Date())),
        title: "问卷标题",
        prefix: "感谢您能抽出几分钟时间来参加本次答题，现在我们就马上开始吧！",
        head_img: "", // 头部图片
        questions: [],
      };
    },
    // 根据时间范围查询
    timeChange() {
      this.getSurveys();
    },
    // 分页查询
    handleCurrentChange(currentPage) {
      this.$set(this.pagination, "current_page", currentPage);

      this.getSurveys();
    },
  },
  components: {
    // HeaderBar,
    RecycleDialog,
  },
};
</script>

<style lang="less" scoped>
@import "~@/assets/font/iconfont.css";
/deep/.el-icon-edit:before {
  margin-left: 5px;
  content: "\E78C";
}
.edit {
  display: flex;
}
.el-select {
  margin-right: 5px;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.tabs {
  color: #000;
}

.current {
  border-bottom: 2px solid #409eff;
  border-radius: 0;
}

/deep/.el-form-item__content {
  text-align: right;
}
.survey_list_table .el-table th.gutter {
  display: table-cell !important;
}
.list_wrap {
  // margin-top: 65px;
  // padding-top: 58px;
  box-sizing: border-box;
}

.list_main {
  width: 100%;
  margin: 0 auto;
  // padding: 0 50px;
  box-sizing: border-box;
}

.action_bar {
  display: flex;
  margin-bottom: 16px;
  position: relative;
  align-items: center;
  justify-content: space-between;

  .filter {
    width: 200px;
  }

  .search_bar > * {
    margin-right: 18px;
  }

  .recycle {
    color: #6f6f6f;
    font-size: 14px;
    cursor: pointer;

    &:hover {
      color: #1d82fc;
    }

    i {
      font-size: 20px;
      margin-right: 5px;
      vertical-align: top;
    }
  }
}

.links {
  display: flex;
  justify-content: space-around;

  .link {
    &:hover {
      color: #1d82fc;
    }

    cursor: pointer;
  }
}

.survey_list_table {
  min-height: calc(100vh - 330px);
}

.home_wrap {
  .el-table {
    color: #6f6f6f;

    .el-table__body tr:hover > td {
      background-color: #ebf7ff !important;
    }
  }

  .list_foot {
    text-align: center;
  }

  .logo {
    & > * {
      display: inline-block;
      vertical-align: middle;
    }

    .logo_text_head {
      color: #1d82fc;
      margin-left: 12px;
    }

    .logo_text_foot {
      color: #d5d5d5;
      margin-left: 12px;
    }

    .cn {
      font-size: 18px;
    }

    .en {
      font-size: 11px;
    }
  }
}

.survey-type-icon {
  width: 12px;
  height: 12px;
}

.progress-bar-wrapper {
  display: flex;
  align-items: center;
  .progress-bar {
    width: 110px;
  }
  .label {
    font-size: 14.4px;
    padding: 5px;
  }
}
</style>
